export const urls = {
  mainURL: "https://strapi.backspark.ru/",
};
